exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-choose-outer {\n  display: block;\n}", ""]);

// exports
